import { defineComponent as _defineComponent } from 'vue'
import { computed } from 'vue';
import { ANNIVERSARY_BANNERS, ANNIVERSARY_LANDING_URL } from '../config';
import { buildBannerSrcSet, buildBannerUrl } from '../lib/buildBannerSrcSet';
import type { Anniversary15BannerVariant } from '../types';

interface Anniversary15PromoBannerProps {
    variant?: Anniversary15BannerVariant;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'Anniversary15PromoBanner',
  props: {
    variant: { default: 'main' }
  },
  setup(__props: any) {

const props = __props as { variant: Anniversary15BannerVariant }



const banner = computed(() => ANNIVERSARY_BANNERS[props.variant]);
const src = computed(() => buildBannerUrl(banner.value.path));
const srcset = computed(() => buildBannerSrcSet(banner.value.path, banner.value.maxDensity));
const testId = computed(() => (props.variant === 'top' ? 'anniversary15-top-banner' : 'anniversary15-promo-banner'));

return { __sfc: true,props, banner, src, srcset, testId, ANNIVERSARY_LANDING_URL }
}

})